module.exports = __webpack_public_path__ + "img/2026_0.8c69dc71.webp";